package components.menus.topbar

import csstype.*
import ics.materialUI.extensions.capitalize
import mui.icons.material.Menu
import mui.icons.material.NavigateNext
import mui.material.*
import mui.material.Size
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC
import react.ReactNode
import react.create
import react.dom.aria.ariaControls
import react.dom.aria.ariaLabel
import react.router.useLocation
import react.router.useNavigate
import theme.Colors

val Topbar = FC<TopbarProps>("Topbar") { props ->
    // hooks
    val location = useLocation()
    val navigate = useNavigate()


    // handlers
    val handleBreadcrumbsGeneration: () -> Array<ReactNode> = {
        val tmpReturnList = mutableListOf<ReactNode>()
        val ignoreList: Array<String> = arrayOf(

        )

        if (location.pathname === "/") {
            tmpReturnList.add(
                Link.create {
                    underline = LinkUnderline.hover
                    color = "#FFF"

                    Typography {
                        variant = TypographyVariant.h6
                        +"Home"
                    }
                }
            )
        } else {
            val tmpLocation = if (location.pathname.startsWith("/")) location.pathname.drop(1) else location.pathname
            val tmpList = tmpLocation.split("/")
            var tmpUrl = ""

            tmpList.forEach { urlPart ->
                if (!urlPart.contains("SSU")) {
                    tmpUrl += "/$urlPart"
                    val finalUrl = tmpUrl

                    tmpReturnList.add(
                        Link.create {
                            underline = LinkUnderline.hover
                            color = "#FFF"
                            if (!ignoreList.contains(urlPart)) {
                                onClick = { _ ->
                                    navigate.invoke(finalUrl)
                                }
                            }

                            sx {
                                hover {
                                    cursor = "pointer".unsafeCast<Cursor>()
                                }
                            }

                            Typography {
                                variant = TypographyVariant.h6
                                +if (!urlPart.contains("_")) urlPart.capitalize() else urlPart.replace("_", " ").capitalize()
                            }
                        }
                    )
                }
            }
        }
        tmpReturnList.toTypedArray()
    }

    // render zone
    AppBar {
        id = "menu-bar"
        position = AppBarPosition.fixed

        if (props.showSidebar) {
            sx {
                width = (100.pct - 300.px)
                marginLeft = 300.px
            }
        }

        Toolbar {

            sx {
                width = 100.pct
            }

            IconButton {
                size = Size.medium
                ariaLabel = "toolbar"
                onClick = {
                    props.showSidebarSetter(!props.showSidebar)
                }
                Menu()
            }

            Box {
                sx {
                    width = (100.pct - 104.px)
                }

                Divider {
                    orientation = Orientation.vertical

                    sx {
                        before {
                            borderColor = Color(Colors.General.main)
                        }
                        after {
                            borderColor = Color(Colors.General.main)
                        }
                    }
                }
                Breadcrumbs {
                    separator = NavigateNext.create()
                    ariaLabel = "breadcrumb"

                    sx {
                        marginLeft = 16.px
                    }

                    handleBreadcrumbsGeneration().forEach {
                        +it
                    }
                }

            }

            Button {
                size = Size.small
                variant = ButtonVariant.text
                ariaLabel = "Account options"
                ariaControls = "menu-appbar"
                color = ButtonColor.inherit

                sx {
                    float = Float.right
                }

                Avatar {
                    +props.session.username.first().toString()
                }
            }
        }

    }

}